import * as React from 'react'
import { SVGProps } from 'react'
const SvgPlayback = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m32.5 28.33-9 5.196c-3.333 1.925-7.5-.48-7.5-4.33V18.804c0-3.85 4.167-6.255 7.5-4.33l9 5.196c3.333 1.924 3.333 6.736 0 8.66ZM31 25.732c1.333-.77 1.333-2.694 0-3.464l-9-5.196c-1.333-.77-3 .192-3 1.732v10.392c0 1.54 1.667 2.502 3 1.732l9-5.196Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29 3H19C10.163 3 3 10.163 3 19v10c0 8.837 7.163 16 16 16h10c8.837 0 16-7.163 16-16V19c0-8.837-7.163-16-16-16ZM19 0C8.507 0 0 8.507 0 19v10c0 10.493 8.507 19 19 19h10c10.493 0 19-8.507 19-19V19C48 8.507 39.493 0 29 0H19Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgPlayback
